var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRinghiera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08464 26.6667C5.3513 26.6667 4.72352 26.4056 4.2013 25.8834C3.67908 25.3612 3.41797 24.7334 3.41797 24V8.00004C3.41797 7.26671 3.67908 6.63893 4.2013 6.11671C4.72352 5.59449 5.3513 5.33337 6.08464 5.33337H27.418C28.1513 5.33337 28.7791 5.59449 29.3013 6.11671C29.8235 6.63893 30.0846 7.26671 30.0846 8.00004V24C30.0846 24.7334 29.8235 25.3612 29.3013 25.8834C28.7791 26.4056 28.1513 26.6667 27.418 26.6667H6.08464ZM6.08464 24H11.418V8.00004H6.08464V24ZM14.0846 24H19.418V8.00004H14.0846V24ZM22.0846 24H27.418V8.00004H22.0846V24Z",
    fill: "#D3135A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRinghiera);
export default __webpack_public_path__ + "static/media/ringhiera.f718adb4bec21c6686cdf8162b539015.svg";
export { ForwardRef as ReactComponent };